import React from 'react'
import moment from 'moment'

// helpers
import { centsToDollars } from 'lib/helpers/money'

// containers
import ModalWrapper from 'components/shared/ModalWrapper'

// components
import Paragraph from 'components/atoms/Paragraph'

function getDayPassRange(product) {
  if (product.volumeDiscountDays) {
    return `1-${product.volumeDiscountDays - 1}`
  }
  if (product.breakEvenDays) {
    return `1-${product.breakEvenDays - 1}`
  }
  return 'any number of'
}

function getVolumeDiscountRange(product) {
  // if product has a volume discount, range is 1-(volume discount days - 1)
  // else if product has break even days, range is 1-(break even days - 1)
  // else range is any number of days

  const endash = '\u2013'

  if (product.volumeDiscountDays) {
    if (product.breakEvenDays) {
      return [product.volumeDiscountDays, product.breakEvenDays - 1].join(
        endash
      )
    } else {
      return `${product.volumeDiscountDays} or more`
    }
  } else {
    return null
  }
}

const DayPassProductInfo = props => {
  const {
    product,
    dayPassPriceCents,
    volumeDiscountPriceCents,
    addDaysPriceCents,
    session,
    modalTitle,
    modalId
  } = props

  // props for retail products
  const refundDate = moment(session.refundDate).format('MMMM D, YYYY')
  const hasVolumeDiscount = product.volumeDiscountDays > 0
  const hasSummerPass = product.breakEvenDays > 0

  // day passes
  const dayPassRange = getDayPassRange(product)
  const volumeDiscountRange = getVolumeDiscountRange(product)

  return (
    <ModalWrapper title={modalTitle} modalId={modalId} closeButton>
      <>
        <Paragraph>
          Good for {session.name} {session.year} only.
        </Paragraph>

        <Paragraph>
          Buy {dayPassRange} Day Passes for one camper at{' '}
          {centsToDollars(dayPassPriceCents)}/Day Pass.
          {hasVolumeDiscount && (
            <>
              {' '}
              Buy {volumeDiscountRange} Day Passes for one camper at{' '}
              {centsToDollars(volumeDiscountPriceCents)}/Day Pass.
            </>
          )}
        </Paragraph>

        <Paragraph>
          One Day Pass covers one day of attendance for one camper, including
          all hours, materials and food.
        </Paragraph>

        <Paragraph>
          With at least one prepaid Day Pass, campers are guaranteed space any
          day at any location, and there is no need to reserve dates in advance.
        </Paragraph>

        <Paragraph>
          Buy additional Day Passes at any time for{' '}
          {centsToDollars(addDaysPriceCents)}/Day Pass.
        </Paragraph>

        {hasSummerPass && (
          <Paragraph>
            Purchase a {product.unlimitedDescription} at any time. All Day
            Passes previously purchased for the current session, will be applied
            as a credit towards the {product.unlimitedDescription}.
          </Paragraph>
        )}

        <Paragraph>
          Day Passes can only be transferred between siblings if both campers
          are registered on the same plan ({centsToDollars(addDaysPriceCents)}
          /Day Pass) at the time of transfer.
        </Paragraph>

        <Paragraph>
          Day Passes are only valid for the selected {session.name} session and
          are not transferable to another session.
        </Paragraph>

        <Paragraph>
          Any unused Day Passes will be fully refunded automatically on{' '}
          {refundDate}.
        </Paragraph>
      </>
    </ModalWrapper>
  )
}

export default DayPassProductInfo
